// Resource codes — must match the `code` field in the resource table
export const RESOURCES = {
  // Top-level pages
  DASHBOARD: 'dashboard',
  CHARGING_DASHBOARD: 'charging_dashboard',

  // Charging Stations
  CHARGING_STATION: 'charging_station',
  CHARGING_STATION_ADD: 'charging_station_add',
  CHARGING_STATION_LIST: 'charging_station_list',
  CHARGING_STATION_TAGS: 'charging_station_tags',
  CHARGING_STATION_BALANCE: 'charging_station_balance',
  CHARGING_STATION_TRANSACTIONS: 'charging_station_transactions',

  // Chargers
  CHARGERS: 'chargers',
  CHARGER_DASHBOARD: 'charger_dashboard',
  CHARGER_ADD: 'charger_add',
  CHARGER_LIST: 'charger_list',
  LOAD_BALANCING: 'load_balancing',

  // Promotions
  PROMOTIONS: 'promotions',
  PROMOTION_ADD: 'promotion_add',
  PROMOTION_LIST: 'promotion_list',

  // Networks
  NETWORKS: 'networks',
  NETWORK_ADD: 'network_add',
  NETWORK_LIST: 'network_list',

  // EV Operators
  EV_OPERATORS: 'ev_operators',
  EV_OPERATOR_ADD: 'ev_operator_add',
  EV_OPERATOR_LIST: 'ev_operator_list',
  EV_OPERATOR_MAPPING: 'ev_operator_mapping',
  EV_OPERATOR_BALANCE: 'ev_operator_balance',
  EV_OPERATOR_TRANSACTIONS: 'ev_operator_transactions',

  // Users
  USERS: 'users',
  USER_ADD: 'user_add',
  USER_LIST: 'user_list',

  // Sessions
  SESSIONS: 'sessions',
  SESSION_LIST: 'session_list',
  SESSION_SUMMARY: 'session_summary',

  // Shifts
  SHIFTS: 'shifts',
  ACTIVE_SHIFTS: 'active_shifts',
  PREVIOUS_SHIFTS: 'previous_shifts',

  // Monitoring
  MONITORING: 'monitoring',
  LIVE_SESSIONS: 'live_sessions',
  LIVE_SESSIONS_MICRO: 'live_sessions_micro',
  LIVE_CHARGERS: 'live_chargers',
  STATUS_NOTIFICATIONS: 'status_notifications',
  CHARGERS_HEARTBEAT: 'chargers_heartbeat',

  // Fleet Management
  FLEET_MANAGEMENT: 'fleet_management',
  FLEET_DASHBOARD: 'fleet_dashboard',
  FLEET_ACCOUNTS: 'fleet_accounts',
  FLEET_ACCOUNTS_UNLINKED: 'fleet_accounts_unlinked',
  FLEETS: 'fleets',
  FLEET_GROUPS: 'fleet_groups',
  FLEET_VEHICLES: 'fleet_vehicles',
  FLEET_VEHICLE_FAILURES: 'fleet_vehicle_failures',

  // Configuration
  PERMISSION_GROUPS: 'permission_groups',

  MAINTENANCE: 'maintenance',
  DIAGNOSTICS_LOGS: 'diagnostics_logs',

}

// Action codes — must match the `action_code` field in the resource_action table
export const ACTIONS = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  EXPORT: 'export',
  // Grants access to the details of a session that belongs to a fleet account,
  // without requiring the session list permission
  FLEET_SESSION: 'fleet_session'
}

// Display labels for action codes used in the permission tree column headers
export const ACTION_LABELS = {
  read: 'View',
  create: 'Create',
  update: 'Edit',
  delete: 'Delete',
  export: 'Export',
  fleet_session: 'Fleet Session'
}

// Fallback label for unknown action codes
export function getActionLabel(code) {
  return ACTION_LABELS[code] ?? code.charAt(0).toUpperCase() + code.slice(1)
}

// Derive a display name from a resource code: "charging_station" → "Charging Station"
export function codeToName(code) {
  return code.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
}

// Flat list of all known resources — used to populate dropdowns in the resource admin UI
export const RESOURCE_LIST = Object.entries(RESOURCES).map(([, code]) => ({
  name: codeToName(code),
  code
}))
